import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: "http://0.0.0.0:8000",
  //baseURL: "http://leo-gonzalez.com",
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth headers
api.interceptors.request.use(
  async (config) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting auth token:', error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Add response interceptor to clean up data
api.interceptors.response.use(
  (response) => response.data,  // Only return the response data
  (error) => {
    const message = error.response?.data?.message || 
                    error.response?.data?.detail ||
                    error.message || 
                    'An unexpected error occurred';
    return Promise.reject(new Error(message));
  }
);


export default api;